import { html, TemplateResult } from "lit-html";
import LocationTypeaheadComponent from '@components/typeahead/location';
import { InputComponent, LabelComponent } from "@components/common";

const MySearchTemplate = async (
  config: ProposalConfigs,
  mySearchesData: IModalMySearch = { what: '', where: '' },
  id: number = 0): Promise<TemplateResult> => {
  const {
    messages: {
      SearchWhat,
      SearchWhere,
      RegistrationWhat,
      ProposalPopupLocationLabel
    }
  } = config;

  const disabled = (!!mySearchesData.what || !!mySearchesData.where);

  const getLocationTypeaheadCssClasses = (): string => `jr-input jr-input-material ${disabled ? 'jr-input-material--disabled' : ''} js-mysearch-what${id}`

  const locationTypeaheadProps: ILocationTypeaheadProps = {
    locationValue: mySearchesData.where,
    placeholder: SearchWhere,
    labelText: ProposalPopupLocationLabel,
    cssClasses: getLocationTypeaheadCssClasses(),
    isLocationLabelEnabled: false,
    clearButtonEnabled: false,
    locationTypeaheadFor: `mySearch-${id}`,
    elementName: `where${id}`
  }

  return html`
    <div class="my-searches-container__row">
      <div class="my-searches-container__input-wrapper">
      ${InputComponent({
    type: 'text',
    name: `what${id}`,
    value: mySearchesData?.what || '',
    placeholder: SearchWhat,
    cssClasses: getLocationTypeaheadCssClasses(),
    options: {
      disabled: !!mySearchesData.what || !!mySearchesData.where,
    }
  })}
      ${LabelComponent({ cssClasses: 'proposal-form__label', labelText: RegistrationWhat })}
      </div>
      <div class="my-searches-container__input-wrapper">
      ${id === 0 ? InputComponent({
    type: 'text',
    name: `where${0}`,
    value: mySearchesData?.where || '',
    cssClasses: getLocationTypeaheadCssClasses(),
    options: {
      disabled: !!mySearchesData.what || !!mySearchesData.where,
    }
  }) : await LocationTypeaheadComponent(locationTypeaheadProps)}
      </div>
    </div>
  `;
}

export default MySearchTemplate;